export function byteToKiloByte(bytes) {
  const size = (bytes / 1024).toFixed(0);
  return size;
}
